import React,{createContext,useState,useEffect} from "react";
import {fetchDataFromApi} from "../utils/api.js"

export const Context = createContext();

export const AppContext = (props) =>{
 const [loading, setLoading] = useState(false);
 const [searchResults, setSearchResults] = useState(false);
 const [selectCategories, setSelectCategories] = useState("New");
 const [mobileMenu, setMobileMenu] = useState(false);
 useEffect(()=>{
    fetchSelectedCategoryData(selectCategories)
 },[selectCategories]);

 const fetchSelectedCategoryData = (query) =>{
setLoading(true)
fetchDataFromApi(`search/?q=${query}`).then(({contents})=>{
    console.log(contents);
    setSearchResults(contents)
    setLoading(false)
})
 }

 return(
    //pass all state and methods, it is use globally
    <Context.Provider value={{
        loading,
        setLoading,
        searchResults,
        setSearchResults,
        selectCategories,
        setSelectCategories,
        mobileMenu,
        setMobileMenu
    }}> 
        {props.children}
    </Context.Provider>
 )
}

